import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import DeviceAccessItem from './DeviceAccessItem'
import type { DeviceAccessInfo, GuestAccessStatus } from '../types/guest'

interface DeviceAccessPanelProps {
  devices: DeviceAccessInfo[]
  userStatus: GuestAccessStatus
  onToggleDevice: (deviceId: number, grant: boolean) => Promise<void>
}

export default function DeviceAccessPanel({
  devices,
  userStatus,
  onToggleDevice,
}: DeviceAccessPanelProps) {
  const isPending = userStatus === 'pending'

  return (
    <div className="bg-gray-50 border-t border-gray-200 p-4">
      {/* Info message for pending users */}
      {isPending && (
        <div className="flex items-start space-x-2 mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
          <FontAwesomeIcon icon={faCircleInfo} className="h-4 w-4 text-blue-500 mt-0.5 flex-shrink-0" />
          <p className="text-sm text-blue-700">
            This user hasn't registered yet. Device access will be available once they complete registration.
          </p>
        </div>
      )}

      {/* Device list */}
      <div className="space-y-2">
        {devices.length === 0 ? (
          <div className="text-center py-6 text-gray-500">
            <p>No devices available</p>
          </div>
        ) : (
          devices.map((device) => (
            <DeviceAccessItem
              key={device.deviceId}
              device={device}
              userStatus={userStatus}
              onToggle={onToggleDevice}
            />
          ))
        )}
      </div>
    </div>
  )
}
